import type { CreatePlatformUserRequest } from '@/bindings/CreatePlatformUserRequest'
import type { PlatformUserSummary } from '@/bindings/PlatformUserSummary'
import type { UpdatePlatformUserRequest } from '@/bindings/UpdatePlatformUserRequest'
import { ApiError } from '@/lib/api'

export interface UserDraft {
  email: string
  firstName: string
  lastName: string
  isAdmin: boolean
}

export function emptyUserDraft(): UserDraft {
  return { email: '', firstName: '', lastName: '', isAdmin: false }
}

export function draftFromUser(user: PlatformUserSummary): UserDraft {
  return {
    email: user.email,
    firstName: user.first_name ?? '',
    lastName: user.last_name ?? '',
    isAdmin: user.is_admin,
  }
}

/** PUT semantics on both routes: blank names clear. */
export function toUserRequest(draft: UserDraft): CreatePlatformUserRequest & UpdatePlatformUserRequest {
  return {
    email: draft.email.trim(),
    first_name: draft.firstName.trim() || null,
    last_name: draft.lastName.trim() || null,
    is_admin: draft.isAdmin,
  }
}

/** Server verdicts that belong on the email field rather than the form. */
export function isEmailError(error: unknown): error is ApiError {
  return error instanceof ApiError && (error.code === 'INVALID_EMAIL' || error.code === 'EMAIL_TAKEN')
}
